import axios from 'axios';
import { BEPI_API } from '../../../shared/config/bepiApiPaths';
import { CatalogHierarchyApi } from '../../../shared/service/catalogHierarchyApi';

// Backend resource path is @Path("web/workshop/.."), mounted under servlet /web/*
const BASE_URL = BEPI_API.workshop;

export const WorkshopEquipamentAddApi = {
  // Seleção hierárquica: Categoria → Produto → Serviço
  getCategorias: () => CatalogHierarchyApi.getCategorias(),
  getProdutosByCategoria: (categoriaId) => CatalogHierarchyApi.getProdutosByCategoria(categoriaId),
  getServicosByProduto: (produtoId) => CatalogHierarchyApi.getServicosByProduto(produtoId),

  // Criar equipamento
  createEquipment: (data) => axios.post(`${BASE_URL}/equipment`, data),
  
  // Buscar equipamento existente (para edição)
  getEquipmentDetails: (id) => axios.get(`${BASE_URL}/equipment/${id}`),
  
  // Fotos
  uploadPhoto: (id, photoData) => axios.post(`${BASE_URL}/equipment/${id}/photos`, photoData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  deletePhoto: (id, photoId) => axios.delete(`${BASE_URL}/equipment/${id}/photos/${photoId}`),
  
  // Laudos
  uploadReport: (id, reportData) => axios.post(`${BASE_URL}/equipment/${id}/reports`, reportData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  deleteReport: (id, reportId) => axios.delete(`${BASE_URL}/equipment/${id}/reports/${reportId}`)
};

